import createUseValue from '@/utils/create-use-value';

export const {
  useValue: useStripeValidation,
  useValueActions: useStripeValidationActions,
} = createUseValue<boolean>(false, 'stripe-validation');
